export default {
    birthday: {
        title: 'Birthdays for the month'
    },
    employment: {
        title: 'Years of service'
    },
    messages: {
        birthday: '<strong>:NAME</strong> celebrates a birthday on the :DAY :MONTH',
        employment: {
            started: '<strong>:NAME</strong> started at the ODQ on the :DATE',
            will_tart: '<strong>:NAME</strong> will start at the ODQ on the :DATE',
            years: '<strong>:NAME</strong> celebrates has been at the ODQ for :YEARS year:S on the :DATE'
        },
    }
}